import React from "react";
import MarkDownLogo from "./Logo";
import GitHub from "../icons/github.svg";
import ThemeToggle from "./ThemeToggle";

function NavBar() {
  return (
    <nav className="navbar">
      <h3 className="title">
        <MarkDownLogo />
        &nbsp;Markdown
      </h3>
      <div className="nav-right">
        <ThemeToggle />
      </div>
    </nav>
  );
}

export default NavBar;
